import { CustomFormat } from "./CustomFormat";

export const customFormatValidator: Record<CustomFormat, (v: string) => boolean> = Object.fromEntries(Object.values(CustomFormat).map(v => ([v, v => typeof v === "string"]))) as Record<CustomFormat, (v: string) => boolean>;
